module.exports = __webpack_public_path__ + "static/media/insuline.d49f42dd.gif";